export interface SkeletonColumnSpec {
  id: string
  width: number
}

export interface LoadingSkeletonRowsProps {
  columns: SkeletonColumnSpec[]
  rowCount?: number
  rowHeight: number
  hasSelectionColumn?: boolean
}

/**
 * 8 skeleton rows matching the real column widths (CLS ≈ 0 — design-system.md
 * §8). The shimmer animation itself is disabled under `prefers-reduced-motion`
 * by the `.iw-skeleton` rule in styles/controls.css, not here.
 */
export function LoadingSkeletonRows({
  columns,
  rowCount = 8,
  rowHeight,
  hasSelectionColumn,
}: LoadingSkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rowCount }, (_, rowIndex) => (
        <div
          key={rowIndex}
          role="row"
          aria-rowindex={rowIndex + 1}
          className="iw-grid-row"
          style={{ height: rowHeight }}
          data-testid="list-skeleton-row"
        >
          {hasSelectionColumn ? (
            <div role="gridcell" className="iw-grid-cell" style={{ width: 40 }}>
              <span className="iw-skeleton" style={{ width: 16, height: 16, display: 'block' }} />
            </div>
          ) : null}
          {columns.map((column) => (
            <div key={column.id} role="gridcell" className="iw-grid-cell" style={{ width: column.width }}>
              <span
                className="iw-skeleton"
                style={{ width: '70%', height: 12, display: 'block' }}
              />
            </div>
          ))}
        </div>
      ))}
    </>
  )
}
